import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BackgroundSurfaceDsComponent } from '@design-system/components/atoms/background-surface/background-surface.component';
import { FixedSurfaceComponent } from '@ux/components/fixed-surface/fixed-surface.component';

@NgModule({
  declarations: [
    FixedSurfaceComponent
  ],
  exports: [
    FixedSurfaceComponent
  ],
  imports: [
    CommonModule,
    BackgroundSurfaceDsComponent,
  ]
})
export class FixedSurfaceModule { }
